import { useContext } from "react";
import { PopupContext } from "./PopupProvider";

export const usePopup = () => {
  const ctx = useContext(PopupContext);
  if (!ctx) {
    throw new Error("usePopup deve ser usado dentro de um <PopupProvider>");
  }
  return ctx;
};
